import ComboBoxGiaoVien from "./ComboBoxGiaoVien";
import SelectBoxGiaoVienMultiple from "./SelectBoxGiaoVienMultiple";
export default ComboBoxGiaoVien
export { SelectBoxGiaoVienMultiple }